export default "__VITE_ASSET__fJ$zFEYM__"